/* eslint-disable import/no-named-default */
import { default as Environments } from './Environments';
import { default as AccountType } from './AccountType';
import { default as ApplicationName } from './ApplicationName';
import { default as ApplicationShortName } from './ApplicationShortName';
import { default as AccountOwner } from './AccountOwner';
import { default as ApplicationOwner } from './ApplicationOwner';
import { default as ApplicationService } from './ApplicationService';
import { default as Sector } from './Sector';
import { default as SQLServerName } from './SQLServerName';
import { default as ServiceAccName } from './ServiceAccName';
import { default as MyPamSafeDropdown } from './MyPamSafeDropdown';

const Forms = {
    Environments,
    AccountType,
    ApplicationName,
    ApplicationShortName,
    AccountOwner,
    ApplicationOwner,
    ApplicationService,
    Sector,
    SQLServerName,
    ServiceAccName,
    MyPamSafeDropdown,
};

export default Forms;
